import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sendMessageNoAvailable } from '../../../redux/actions/A_messages_to_SM';
import { removeWorkAction } from '../../../redux/actions/A_workBar_selected';
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller';
import { getNoAvailableList, setNoAvailableList, observerNoAvailableList, getNoAvailableRecord, setNoAvailableRecord, observerRecordNAhistory } from '../../../js/Singletons/NoAvailableRecordSingleton.js';
import { DRAGGABLE_WINDOWS, USER_STATE, WORKBAR_ACTIONS } from '../../../constants';
import { clock2 } from '../../../Images/NoAvailableSVG';
import { infinito, clockIcon } from '../../../Images/GenericSVG';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';
import { alertQueryErrorBody } from '../../../js/alertQueryErrorBody';
import { consultingApp, noConsultingApp } from '../../../redux/actions/A_reducer_consulting';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import { getCurrentTimeInSec } from '../../../js/helpers/Utils/formats.js';

class NoAvailableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { noAvailableList: [], noAvailableRecord: [] };
    this._isMounted = false;
    this.language = new Singleton();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.sharedData = new SingletonSharedData();
    this.restricted = 0;
  }
  componentDidMount() {    
    this._isMounted = true;
    if (this.props.floating) {
      setNoAvailableList(null);
      observerNoAvailableList(null);
      setNoAvailableRecord(null);
      observerRecordNAhistory(null);
    }
    let userId = this.sharedData.getParameters().UserID;
    let _this = this;
    let timeOut = this.sharedData.getRequestTimeout();
      if (!this.props.floating) {
        this.props.consultingApp();
        let objectResponse = this.apiCont.getObjectResponse();
        this.apiCont.getListNoAvailable(userId, objectResponse, timeOut);
        objectResponse.onError = function (messageError) {
          console.warn(messageError);
          _this.props.noConsultingApp();
        };
        objectResponse.onCatch = function (messageError) {
            console.warn(messageError);
            _this.props.noConsultingApp();
            _this.props.showAlertModal(alertQueryErrorBody()); 
        };
        objectResponse.onSuccess = function (objResponse) {
          _this.props.noConsultingApp();
          if(objResponse.Response){
            setNoAvailableList(objResponse.Response);
            if (_this._isMounted) {
              _this.setState({ noAvailableList: getNoAvailableList() });
            }
          }
        };
      } else {
        observerNoAvailableList(() => { this.setState({ noAvailableList: getNoAvailableList() }) });
      }
    if (!getNoAvailableRecord()) {
        let objectResponse = this.apiCont.getObjectResponse();
        this.apiCont.getNotReadyHistory(userId, objectResponse, timeOut);
        this.props.consultingApp();
        objectResponse.onError = function (messageError) {
          console.warn(messageError);
          _this.props.noConsultingApp();
        };
        objectResponse.onCatch = function (messageError) {
            _this.props.showAlertModal(alertQueryErrorBody());  
            console.warn(messageError);
            _this.props.noConsultingApp();
          };
        objectResponse.onSuccess = function (objResponse) {
          setNoAvailableRecord(objResponse.Response);
          if (_this._isMounted) {
            _this.setState({ noAvailableRecord: getNoAvailableRecord() });
          }
          _this.props.noConsultingApp();
        };
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timerMessageNoAvailable);
    if (this.props.floating) {
      setNoAvailableList(null);
      observerNoAvailableList(null);
      setNoAvailableRecord(null);
      observerRecordNAhistory(null);
    }
    
  }

  noAvailableSelection(notReadyId) {
    let conversationID = null;
    if(this.props.userState.currentState === USER_STATE.DIALOG_WHATSAPP && this.props.unifiedInboxState.selectedID !== null){
      conversationID = this.props.unifiedInboxState.selectedID;
    }
    let isPreview = this.sharedData.getDataPreviewPro().dialingMode === 1;
    let timeInPreview = isPreview ?  this.getPreviewTime() : 0;
    this.props.sendMessageNoAvailable(this.sharedData.getUserData().Login, this.sharedData.getParameters().UserID, notReadyId, conversationID, timeInPreview);
    this.timerMessageNoAvailable = setTimeout(() => { this.closeNoAvailable(); }, 20);
  }
  getPreviewTime(){
    let time = getCurrentTimeInSec();
    let previewTime = time - this.props.preview.initialTimeSec +  this.props.preview.totalPreviewTime;
    return previewTime;
  }
  closeNoAvailable() {
    this.props.removeWorkAction(WORKBAR_ACTIONS.NO_AVAILABLE);
    this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE);
  }
  totalSelectionItem(idItem) {
    let items = [];
    if (this.state.noAvailableRecord) {
      items = this.state.noAvailableRecord.filter((item) => { return item.TypeNotReadyId === idItem; });
    }
    if (items.length === 0) {
      return 0;
    }
    return items[0].Count;
  }
  totalTimeItem(idItem) {
    let items = this.state.noAvailableRecord.filter((item) => { return item.TypeNotReadyId === idItem; });
    if (items.length === 0) {
      return "00:00:00";
    }
    return items[0].Time;
  }
  infoTimesNA(item, ITEM) {
    let time = (item.Max.split(':').reduce((acc, time) => (60 * acc) + +time));
    if (item.NumberOfEvents !== "n" && time > 0) {//TIENE TIEMPO MAXIMO Y NUMERO DE EVENTOS
      return <div>
        <div className={`iconInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{clockIcon}</div>
        <p className={`textInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{item.Max}</p>
        {!ITEM.length && <p className={`textInfoNA right ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.totalSelectionItem(item.TypeNotReadyId) + "/" + item.NumberOfEvents}</p>}
        {(ITEM.length === 1) && <p className={`textInfoNA right ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{ITEM[0].Count + "/" + ITEM[0].Total}</p>}
      </div>
    }
    if (item.NumberOfEvents === "n" && time > 0) {//NUMERO DE EVENTOS ILIMITADOS CON TIEMPO MAXIMO
      return <div>
        <div className={`iconInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{clock2}</div>
        <p className={`textInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.totalTimeItem(item.TypeNotReadyId)}</p>
        <p className={`textInfoNA right ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{item.Max}</p>
        <div className="iconInfoNA right">{clockIcon}</div>
      </div>
    }
    if (item.NumberOfEvents !== "n" && time === 0) {//NUMERO DE EVENTOS ILIMITADOS CON TIEMPO MAXIMO
      return <div>
        <p className={`textInfoNA right ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.totalSelectionItem(item.TypeNotReadyId) + "/" + item.NumberOfEvents}</p>
      </div>
    }
    if (item.NumberOfEvents === "n" && time === 0) {//NUMERO DE EVENTOS ILIMITADOS CON TIEMPO ILIMITADO
      return <div>
        <div className={`iconInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{clock2}</div>
        <p className={`textInfoNA ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.totalTimeItem(item.TypeNotReadyId)}</p>
        <div className={`textInfoNA right ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{infinito}</div>
      </div>
    }
  }
  percentFullBar(item, ITEM) {
    let time = (item.Max.split(':').reduce((acc, time) => (60 * acc) + +time));
    if (ITEM.length) { 
      let hoursInSeconds = parseInt(ITEM[0].Time.substring(0, 2) * 3600, 10) ;
      let minutesInSeconds =  parseInt(ITEM[0].Time.substring(3, 5) * 60, 10);
      let seconds =  parseInt(ITEM[0].Time.substring(6, 8), 10);
      const time2 = hoursInSeconds + minutesInSeconds + seconds;
      if (ITEM[0].Total !== "n") {//TIENE NUMERO DE EVENTOS
        let p1 = ITEM[0].Count * 100 / ITEM[0].Total;
        let p2 = time2 * 100 / time;
        p2 = (p2 > 100 ? 100 : p2);
        return (p1 > p2 ? p1 : p2);
      }
      if (time > 0) {//TIENE TIEMPO MAXIMO
        let p2 = time2 * 100 / time;
        p2 = (p2 > 100 ? 100 : p2);
        return p2;
      }
    }
    return 0;
  }
  renderNA2(item, i) {
    let ITEM = [];
    if (this.state.noAvailableRecord !== null) {
      ITEM = this.state.noAvailableRecord.filter((noAvailable) => { return noAvailable.Description === item.Description });
    }
    let percent = this.percentFullBar(item, ITEM);
    return <div className={`NoAvailableItem ${percent >= 100 ? "full" : ""} ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`} 
    key={"item" + i}
      onClick={() => (!this.restricted && this.noAvailableSelection(item.TypeNotReadyId))}>
      <div className={`IconSVGNoAvailable  ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{this.sharedData.getIconNoAvailable(item.Frame)}</div>
      <div className={`containerInfoNA  ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>
        <p className={`NoAvailableTxtItem  ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>{item.Description}</p>
        <div className={`completeBar ${(item.NumberOfEvents === "n" && item.Max === "00:00:00" ? "infinite" : "")}  ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>
          <div className={"percentageBar " + (percent >= 100 ? "full" : "")} style={{ width: percent + "%" }}></div></div>
        {this.infoTimesNA(item, ITEM)}
      </div>
    </div>;
  }


  render() {
    const unavailablesList = this.state.noAvailableList;
    if (unavailablesList != null && unavailablesList.length) {
      this.restricted = unavailablesList[0].NotReadyRestricted
    }
    return (
      <div className={`noAvailableScrollContainer01 ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''}`}>
        <div className={`noAvailableScrollContainer ${(this.restricted ? "blur" : "")} ${this.props.preview.simultaneosRecs ? 'simultaneosRecs': ''} `}>
          {this.state.noAvailableList.map((item, i) =>
            this.renderNA2(item, i))}
        </div>
        {(this.restricted ? <div className="NoAvailableRestricted">
          <p className="NoAvailableRestrictedMessage">{this.language.getText("alert-1509")}</p>
        </div> : "")}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { 
    userState: state.userState, 
    unifiedInboxState: state.unifiedInboxState, 
    preview: state.preview
  }
}

function mapDispatchToProps(dispatch) {
 const { showAlertModal } = AlertModalActions.creators;  
  return ({
    sendMessageNoAvailable: (userName, userID, notReadyID, conversationID,timeInPreview) => { dispatch(sendMessageNoAvailable(userName, userID, notReadyID, conversationID,timeInPreview)); },
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    removeWorkAction: (idRemove) => { dispatch(removeWorkAction(idRemove)); },
    consultingApp: () => { dispatch(consultingApp()); },
    noConsultingApp: () => { dispatch(noConsultingApp()); },
    showAlertModal: payload => {
        dispatch(showAlertModal(payload));
      },
  });
}

export default NoAvailableComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoAvailableComponent);



// WEBPACK FOOTER //
// ./src/components/workSpace/FloatingSideComponents/NoAvailableComponent.jsx